import { useNavigate } from "react-router-dom";

const BannerEnd = () => {
  const navigate = useNavigate();

  return (
    <div
      className="w-full relative flex items-center justify-center bg-cover bg-center py-40 sm:py-20 lg:py-40"
      style={{ height: "auto" }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227242/image-banner-end-2_igvsdr.png)`,
        }}
      ></div>
      <div
        className="absolute inset-0 bg-cover bg-center hidden sm:block lg:block"
        style={{
          backgroundImage: `url(https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227246/image-banner-end_gdugld.png)`,
        }}
      ></div>

      {/* Overlay mờ */}
      <div className="relative z-10 text-center text-white px-4 sm:px-0 lg:px-0">
        <h1 className="text-4xl sm:text-4xl lg:text-6xl font-bold">
          Sản phẩm tuyệt vời
        </h1>
        <p className="mt-4 text-md sm:text-xl lg:text-xl">
          Chúng tôi mang đến trải nghiệm hoàn hảo dành cho bạn.
        </p>
        <button
          onClick={() => navigate(`/contact`)}
          className="mt-6 px-6 py-3 bg-white text-black font-semibold rounded-md hover:bg-gray-200 transition"
        >
          Liên hệ ngay
        </button>
      </div>
    </div>
  );
};
export default BannerEnd;
